const { readCsrfToken, syncCsrfTokenMeta } = require('../auth/shared/csrf');
const { handleSessionFailure, resolveLoginUrl } = require('../helpers/session-expired');

$.fn.dataTable.ext.errMode = 'none';

function onReady(callback) {
    var intervalID = window.setInterval(checkReady, 1000);

    function checkReady() {
        if (document.getElementsByTagName("body")[0] !== undefined) {
            window.clearInterval(intervalID);
            callback.call(this);
        }
    }
}

function show(selector, value) {
    if (value) {
        $(selector).fadeIn();
    } else {
        $(selector).fadeOut();
    }
}

onReady(function() {
    show(".preloader", false);
});
$( document ).ajaxSend(function() {
    let body = $('body');
    if(!body.hasClass('no-loader')) {
        if(!body.hasClass('no-loader-page')) {
            if($('.modal-backdrop').length) {
                $('.modal-backdrop').css('opacity', 0);
            }
            show('.preloader', true);
        }
    }
});
$( document ).ajaxStop(function(e) {
    let body = $('body');
    if(!body.hasClass('no-stop-loader')) {
        show('.preloader', false);
        if ($('.modal-backdrop').length) {
            $('.modal-backdrop').css('opacity', '');
        }
        body.removeClass('no-loader');
    }
});
$(document).ajaxError(function(event, request, settings) {
    if (request.status != 419) {
        return;
    }

    if (!settings.__csrfRetried) {
        settings.__csrfRetried = true;
        const token = syncCsrfTokenMeta() || readCsrfToken();
        settings.headers = Object.assign({}, settings.headers, {
            'X-CSRF-TOKEN': token,
        });

        $.ajax(settings);
        return;
    }

    handleSessionFailure(request, resolveLoginUrl(window.location.pathname));
});
